/**
 * `useDebouncedCallback` hook allows for a simple throttled
 * callback utilizing `useCallBack`
 */

import * as React from "react"

/**
 * FIXME: Something is wrong with this implementation and is preventing me from using it
 * with Tether for debouncing position updates based on scroll.
 */
/**
 * @param onChange
 * @param delay Debounce delay (milliseconds) for triggering onChange handler @default 100
 */
const useDebouncedCallback = (onChange: () => void, delay = 100) => {
  const debounce = React.useRef(0)
  const changeHandler = React.useCallback(() => {
    if (debounce.current) clearTimeout(debounce.current)
    debounce.current = setTimeout(onChange, delay)
  }, [delay, onChange])

  React.useEffect(
    () => () => {
      clearTimeout(debounce.current)
    },
    [debounce]
  )

  return changeHandler
}

export default useDebouncedCallback
